var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoggedIn)?_c('NavigationTree',{attrs:{"roots":_vm.menu,"locale-section":"components.navigationMain"}}):_vm._e(),(!_vm.isLoggedIn)?_c('NavigationTree',{attrs:{"roots":_vm.loginMenu,"locale-section":"components.navigationMain"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }